module.exports = __webpack_public_path__ + "img/money_ball.5419cef8.png";